<script>
import { required } from 'vuelidate/lib/validators'

import axios from 'axios'


export default {
	props: {
		url: {
			type: String,
			default: '/pan/xdr/indicators/info/top?limit=10000',
		}
	},
	data() {
		return {
			category: 'List',
			items: [
				{
					text: 'Home',
					href: '/',
				},
				{
					text: 'Indicators View',
					active: true,
				},
			],
			appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
			incidents: [],
			tableData: [],
			totalRows: 1,
			currentPage: 1,
			perPage: 10,
			pageOptions: [10, 25, 50, 100],
			filter: null,
			filterOn: [],
			sortBy: 'reputation',
			sortDesc: true,
			fields: [
				{ key: 'indicator', label: 'Indicator', sortable: true },
				{ key: 'reputation', label: 'Reputation', sortable: true },
				{ key: 'updated', label: 'Updated', sortable: true },
				{ key: 'country', label: 'Country', sortable: true },
				{ key: 'incidents_high', label: 'Incidents High', sortable: true },
				{ key: 'incidents', label: 'Incidents', sortable: true },
				{ key: 'adversary', label: 'Adversary', sortable: true },
				{ key: 'groups', label: 'Groups', sortable: true },
				{ key: 'malware_families', label: 'Malware Families', sortable: true },
				{ key: 'targeted_countries', label: 'Targeted Countries', sortable: false },
			],
			isBusy: true
		}
	},
	validations: {
		event: {
			title: { required },
			category: { required },
		},
	},
	computed: {
		rows() {
			return this.tableData.length
		},
	},
	mounted () {
		this.loadData()
	},
	methods: {
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		loadData () {
			let that = this
			that.isBusy = true
			// if (process.env.NODE_ENV === 'production' && that.$store.state.idToken === undefined) return
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      console.log('base url', baseURL)
      console.log(' url', that.url)

			// let headers = {
			// 	"Authorization": that.$store.state.id_token
			// }
			// axios.get(`${baseURL}${that.url}`, { headers: headers }).then((response) => {
			axios.get(`${baseURL}${that.url}`).then((response) => {
				if (response.status === 200) {
					that.tableData = response.data.data.map(function(entry){
						return {
							indicator: entry.indicator,
							reputation: entry.reputation,
							updated: new Date(entry.last_update['$date']).toLocaleString(),
							country: entry.country_code,
							incidents_high: entry.incidents_high,
							incidents: entry.incidents,
							adversary: entry.adversary,
							groups: entry.groups,
							malware_families: entry.malware_families,
							targeted_countries: entry.targeted_countries,
						}
          })
          that.totalRows = that.tableData.length
				}
				that.isBusy = false
			})
			.catch(function (error) {
				if (error.response.status === 401 || error.response.status === 403) {
					localStorage.removeItem('idToken')
					that.$router.push({ name: 'Home' })
				}
			}) 
			that.totalRows = that.tableData.length
		},
	},
}
</script>

<template>
	<div>
		<div class="row mb-md-2">
			<div class="col-sm-6 col-md-6">
				<span>
					Found: 
					<b>
						{{ totalRows }}
					</b>
					at
					<b>
						{{ new Date().toLocaleString() }}
					</b>
				</span>
			</div>

			<div class="col-sm-6 col-md-6">
				<div
					id="tickets-table_filter"
					class="dataTables_filter text-md-right"
				>
					<label class="d-inline-flex align-items-center">
						Search:
						<b-form-input
							v-model="filter"
							type="search"
							placeholder="Search..."
							class="form-control form-control-sm ml-2"
						></b-form-input>
					</label>
				</div>
			</div>
		</div>
		<div class="table-responsive mb-0">
			<b-table
				:items="tableData"
				:fields="fields"
				:busy="isBusy"
				responsive="sm"
				:per-page="perPage"
				:current-page="currentPage"
				:sort-by.sync="sortBy"
				:sort-desc.sync="sortDesc"
				:filter="filter"
				:filter-included-fields="filterOn"
				@filtered="onFiltered"
			>
				<template v-slot:table-busy>
					<div class="text-center">
					<br><br>
					<b-spinner class="align-middle"></b-spinner>
					<strong>&nbsp;&nbsp;Loading...</strong>
					</div>
				</template>
				<template v-slot:cell(incidents_high)="data">
          <span class="severity_high">
            {{ data.item.incidents_high.join(', ') }}
          </span>
				</template>
				<template v-slot:cell(incidents)="data">
            {{ data.item.incidents_high.join(', ') }}
				</template>
				<template v-slot:cell(adversary)="data">
            {{ data.item.adversary.join(', ') }}
				</template>
				<template v-slot:cell(groups)="data">
            {{ data.item.groups.join(', ') }}
				</template>
				<template v-slot:cell(malware_families)="data">
            <div v-for="(malware, index) in data.item.malware_families" v-bind:key="index">
              {{ malware.display_name + ', '}}
            </div>
				</template>
				<template v-slot:cell(targeted_countries)="data">
            {{ data.item.targeted_countries.join(', ') }}
				</template>
			</b-table>
		</div>
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<div id="tickets-table_length" class="dataTables_length">
					<label class="d-inline-flex align-items-center">
						Show&nbsp;
						<b-form-select
							v-model="perPage"
							size="sm"
							:options="pageOptions"
						></b-form-select
						>&nbsp;entries
					</label>
				</div>
			</div>
			<div class="col">
				<div
					class="dataTables_paginate paging_simple_numbers float-right"
				>
					<ul class="pagination pagination-rounded mb-0">
						<b-pagination
							v-model="currentPage"
							:total-rows="totalRows"
							:per-page="perPage"
						></b-pagination>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>
